import axios from 'axios';
import { config } from '../config/config';
import { openNotificationWithIcon } from './toast';

/**
 * This module is not a React component, so the useNavigate hook cannot be used
 * here -- the previous `const navigate = useNavigate` assigned the hook itself,
 * and calling it threw instead of redirecting. A full-document navigation is the
 * correct primitive outside the router tree, and it also clears in-memory state,
 * which is what we want when a session ends.
 */
const redirectToLogin = () => {
  try {
    localStorage.clear();
  } catch (e) {
    // private mode / blocked storage -- redirect anyway
  }
  if (window.location.pathname !== '/') {
    window.location.replace('/');
  }
};
const instance = axios.create({
  baseURL: config.API_BASE_URL,
  responseType: "json",
  timeout: 20000,
  timeoutErrorMessage: 'Server Timeout'
});

instance.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = token
    }
    return config;
  },
  function (error) {
    console.log(error, "eooooo")
    return Promise.reject(error);
  }
);


instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {

    const { response } = error;
    if (response) {
      // An expired or invalid token was previously unhandled: the app shell kept
      // rendering while every request failed, and nothing logged the user out.
      if (response.status === 401) {
        openNotificationWithIcon("error", "Your session has expired. Please log in again.");
        redirectToLogin();
        return Promise.reject(error);
      }
      if (response?.data?.data?.disabled === true) {
        openNotificationWithIcon("error", "Your account is disabled. Kindly contact Admin.");
        return Promise.reject(error);
      }
      if (response?.data?.data?.deleted === true) {
        openNotificationWithIcon("error", "Your account is deleted. Kindly contact Admin.");
        redirectToLogin();
        return Promise.reject(error);
      }
      else if (response?.data?.data?.permission === false) {
        openNotificationWithIcon("error", "You are not allowed to perform this action.");
        return Promise.reject(error);
      }
      else {
        return Promise.reject(error);
      }
    } else {
      // Network error or other errors without a response
      openNotificationWithIcon("error", "Network error. Please check your connection.");
      return Promise.reject(error);
    }
  }
);
export default instance